import { BrowserModule } from '@angular/platform-browser';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
//for pagination kauhsalya(2017-07-31)
import {NgxPaginationModule} from 'ngx-pagination';
//Third_party_Module
import { ToastyModule } from 'ng2-toasty';
import { TranslateModule, TranslateLoader, TranslateStaticLoader } from 'ng2-translate';
//Define_Module
import { MainModule } from "./modules/main.module";
import { LoginModule } from "./login/login.module";

import { SharedModule } from "./shared/shared.module";
import { PipeCapitalizeModule } from './shared/modules/pipe-capitalize/pipe-capitalize.module';
//Routing
import { appRouting, appRoutingProviders } from './app.routes';
//Component
import { AppComponent } from './app.component';
import { PageNotfoundComponent } from './shared/components/page-notfound/page-notfound.component';
//Constant
import { Constants } from './app.const';

import { DevelopmentModule } from './shared/modules/development/development.module';

export function TranslateStaticLoaderFactory(http: Http) {
  return new TranslateStaticLoader(http, Constants.urlTranslate, Constants.extenstionJson);
}

@NgModule({
  declarations: [
    AppComponent,
    PageNotfoundComponent,
  ],
  imports: [
    BrowserModule,
    FormsModule,
    HttpModule,
    NgxPaginationModule,
    ToastyModule.forRoot(),
    TranslateModule.forRoot({
      provide: TranslateLoader,
      useFactory: TranslateStaticLoaderFactory,
      deps: [Http]
    }),

    MainModule,
    SharedModule,
    PipeCapitalizeModule,
    appRouting,
    DevelopmentModule,
    LoginModule
  ],
  providers: [appRoutingProviders],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts